'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minuteBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/minuteBefore.js
// module id = 706
// module chunks = 0